jQuery(document).ready(function($){

  $("header nav ul.site-nav li ul").each(function () {
    if ($(this).children("li").length > 10) {
      $(this).addClass("grid-4-col");
    }
  });

  
  let dropdownTimer;

  jQuery('.site-nav--has-dropdown').on('mouseenter', function () {
    clearTimeout(dropdownTimer);

    // Close all other dropdowns
    jQuery('.site-nav--has-dropdown').not(this).removeClass('site-nav--active-dropdown');

    // Open the current one
    jQuery(this).addClass('site-nav--active-dropdown');
  });

  jQuery('.site-nav--has-dropdown').on('mouseleave', function () {
    const $this = jQuery(this);
    dropdownTimer = setTimeout(function () {
      $this.removeClass('site-nav--active-dropdown');
    }, 300); // delay allows moving into dropdown
  });



  // Check if the URL contains "collections/new-equipment"
  if (window.location.pathname.includes('/collections/new-equipment')) {
    $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-value').each(function() {
      const text = $(this).text();
      if (text.includes('Toro') || text.includes('Husqvarna') || text.includes('Bluebird')) {
        $(this).parent('button').parent('li').hide();
      }
    });
  }


  // Look inside dropdown menus for an item with "Brands" text
  $('header .site-nav__dropdown .site-nav__label').each(function() {
    if ($(this).text().trim() === "New Equipment"){
      $(this).addClass('menu-heading');
      $(this).parent('a').parent('li').addClass('fullRow');
    }
  });

});
